import React from "react";
import { NavLink } from "react-router-dom";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import logo from "../assets/images/logo-Photoroom.png";
import { demoAccountMenu } from "../data/header";
import {useAuth} from "../hooks/auth";

function DemoHeader() {
  const { signOut } = useAuth();
  return (
    <Navbar expand="lg" className="navbar-new bg-light fixed">
      <Navbar.Brand href="/">
        <img src={logo} alt="logo" className="navbar-new-logo" />
      </Navbar.Brand>
      <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse id="basic-navbar-nav">
        <Nav className="me-auto demo-navbar">
          {demoAccountMenu.map((menu, index) => (
            <NavLink
              key={index}
              exact
              to={menu.navigate}
              activeClassName="active-item" // ✅ React Router v5 style
              className="dropdown-item-custom"
            >
              {menu.title}
            </NavLink>
          ))}
        </Nav>

        <div className="navbar-buttons">
          {/* <NavLink to="/create-account" className="custom-btn">
            New Account
          </NavLink> */}
          <button onClick={signOut} className="custom-outline-btn">
            Logout
          </button>
        </div>
      </Navbar.Collapse>
    </Navbar>
  );
}

export default DemoHeader;
